export type EventViewStatus = "ACTIVE" | "DRAFT" | "INACTIVE" | string | null | undefined;

const DEFAULT_PUBLIC_SITE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080"
    : "https://www.unifteconline.com.br";

const PUBLIC_SITE_URL =
  process.env.REACT_APP_PUBLIC_SITE_URL ||
  process.env.REACT_APP_SITE_URL ||
  process.env.REACT_APP_WEBSITE_URL ||
  DEFAULT_PUBLIC_SITE_URL;

export const canViewEvent = (status: EventViewStatus, slug?: string | null) =>
  !!slug && (status === "ACTIVE" || status === "DRAFT");

const hasFuturePublishOn = (publishOn?: string | null) => {
  if (!publishOn) return false;

  const publishDate = new Date(publishOn);

  return !Number.isNaN(publishDate.getTime()) && publishDate > new Date();
};

export const getEventViewUrl = (
  status: EventViewStatus,
  slug?: string | null,
  publishOn?: string | null
) => {
  if (!slug) return "";

  const shouldPreview =
    status === "DRAFT" || (status === "ACTIVE" && hasFuturePublishOn(publishOn));
  const path = shouldPreview ? `/eventos/rascunho/${slug}` : `/eventos/${slug}`;

  return `${PUBLIC_SITE_URL.replace(/\/$/, "")}${path}`;
};

export const eventViewButtonSx = {
  minWidth: 112,
  height: 40,
  borderRadius: 2,
  fontWeight: 700,
  color: "#1a73e8 !important",
  borderColor: "#1a73e8 !important",
  backgroundColor: "#fff !important",
  boxShadow: "none",
  opacity: "1 !important",
  cursor: "pointer",
  "&:hover": {
    borderColor: "#155fc0 !important",
    backgroundColor: "#f3f8ff !important",
  },
  "&:disabled, &.Mui-disabled": {
    color: "#94a3b8 !important",
    borderColor: "#d8dee9 !important",
    backgroundColor: "#f8fafc !important",
    boxShadow: "none !important",
    opacity: "1 !important",
    cursor: "not-allowed",
  },
  "&:disabled .MuiSvgIcon-root, &.Mui-disabled .MuiSvgIcon-root": {
    color: "#cbd5e1 !important",
  },
  "&.Mui-disabled": {
    pointerEvents: "none",
  },
  "& .MuiButton-startIcon": {
    marginRight: 0.75,
  },
  "& .MuiSvgIcon-root": {
    color: "inherit !important",
  },
};
